import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { CentroEntrenamiento } from '../../models/centro-entrenamiento.model';
import { CentroEntrenamientoService } from '../../services/centro-entrenamiento.service';
import { Instructor } from '../../models/instructor.model';

@Component({
  selector: 'app-centros-entrenamiento',
  templateUrl: './centros-entrenamiento.component.html',
  styleUrls: ['./centros-entrenamiento.component.css']
})
export class CentrosEntrenamientoComponent implements OnInit {
  //listas
  centros: CentroEntrenamiento[] = [];
  filteredCentros: CentroEntrenamiento[] = [];
  instructores: Instructor[] = [];
  //filtros de busqueda
  searchId: number | null = null;
  searchNombre: string = '';
  searchDireccion: string = '';
  searchIdInstructor: number | null = null;
  activos: boolean = true;
  inactivos: boolean = true;
  orderBy: string = 'id';
  orderDirection: string = 'asc';
  //se guardan los valores iniciales del item
  initialCentroState: { [key: number]: Partial<CentroEntrenamiento> } = {};
  //informacion
  errorMessages: { [key: number]: string | null } = {};
  showPopup: boolean = false;
  savedData: any = null;
  

    constructor(
      private sharedService: SharedService,
      private centrosEntrenamientoService: CentroEntrenamientoService,
    ) {}

    ngOnInit(): void {
      this.subscribeCentros();
      this.sharedService.instructores$.subscribe(
        (instructores) => { this.instructores = instructores; },
        (err) => { console.error('Error fetching instructores:', err); }
      );
    }

    subscribeCentros(): void {
      this.sharedService.centros$.subscribe(
        (centros) => {
          this.centros = centros.map(data => CentroEntrenamiento.fromRawData(data));
          this.filterCentros(); // Apply filters after fetching centros
        },
        (err) => {
          console.error('Error fetching centros:', err);
        }
      );
    }

    resetCentros(): void {    
      this.sharedService.fetchCentros().subscribe(
      (centros) => {
        this.centros = centros.map(data => CentroEntrenamiento.fromRawData(data));
        this.filterCentros(); // Apply filters after fetching centros
      },
      (err) => {
        console.error('Error fetching centros:', err);
      }
    );
  }

  filterCentros(): void {
    this.filteredCentros = this.centros.filter(centro => {
      return (
        (this.searchNombre === '' || centro.nombre?.toUpperCase().includes(this.searchNombre.toUpperCase())) &&
        (this.searchDireccion === '' || centro.direccion?.toUpperCase().includes(this.searchDireccion.toUpperCase())) &&
        (this.searchId === null || centro.id === this.searchId) &&
        (this.searchIdInstructor === null || centro.idInstructor === this.searchIdInstructor) &&
        ((this.activos && centro.activo) || (this.inactivos && !centro.activo))
      );
    });
    this.filteredCentros.sort((a, b) => {
      let comparison = 0;
      if (this.orderBy === 'id') {
        comparison = (a.id || 0) - (b.id || 0);
      } else if (this.orderBy === 'nombre') {
        comparison = (a.nombre || '').localeCompare(b.nombre || '');
      } else if (this.orderBy === 'direccion') {
        comparison = (a.direccion || '').localeCompare(b.direccion || '');
      } else if (this.orderBy === 'instructor') {
        comparison = (a.idInstructor || 0) - (b.idInstructor || 0);
      }
      return this.orderDirection === 'asc' ? comparison : -comparison;
    });
  }

  clearFilters(): void {
    this.searchNombre = '';
    this.searchDireccion = '';
    this.searchId = null;
    this.searchIdInstructor = null;
    this.activos = true;
    this.inactivos = true;
    this.orderBy = 'id';
    this.orderDirection = 'asc';
    this.filterCentros();
  }

  toggleEditMode(centro: CentroEntrenamiento): void {
    if (centro.isEditMode) {
      this.restoreInitialState(centro);
    } else {
      this.saveInitialState(centro);
    }
    centro.isEditMode = !centro.isEditMode;
  }

  saveInitialState(centro: CentroEntrenamiento): void {
    this.initialCentroState[centro.id] = {
      id: centro.id,
      nombre: centro.nombre,
      direccion: centro.direccion,
      idInstructor: centro.idInstructor,
      activo: centro.activo,
      disableValidation: centro.disableValidation
    };
  }

  restoreInitialState(centro: CentroEntrenamiento): void {
    const initialState = this.initialCentroState[centro.id];
    if (initialState) {
      Object.assign(centro, initialState);
    }
  }

  addCentro(): void {
    this.clearFilters();
    const newCentro = new CentroEntrenamiento(0, "", "", 0, true, true, true); // Initialize nroLibreta as null
    newCentro.isEditMode = true;
    newCentro.disableValidation = true;
    this.centros.unshift(newCentro);
    this.filterCentros();
  }

  cancelAddCentro(centro: CentroEntrenamiento): void {
    this.centros = this.centros.filter(i => i !== centro);
    this.filterCentros();
  }

  afterSave(savedCentro: CentroEntrenamiento): void {
    savedCentro.isEditMode = false;
    const { isEditMode, idInstructor, ...rest } = savedCentro;
    // Convert idInstructor to number to ensure proper matching
    const instructorObj = this.instructores.find(i => i.id === Number(idInstructor));
    const instructorName = instructorObj ? 
      instructorObj.nombreApellido + (!instructorObj.activo ? ' - INACTIVO' : '') : 
      idInstructor;
    const dataToSave = { ...rest, instructor: instructorName };
    this.savedData = dataToSave;
    this.showPopup = true;
    this.resetCentros();
  }

  afterUpdate(updatedCentro: CentroEntrenamiento): void {
    updatedCentro.isEditMode = false;
    const { isEditMode, idInstructor, ...rest } = updatedCentro;
    // Convert idInstructor to number to ensure proper matching
    const instructorObj = this.instructores.find(i => i.id === Number(idInstructor));
    const instructorName = instructorObj ? 
      instructorObj.nombreApellido + (!instructorObj.activo ? ' - INACTIVO' : '') : 
      idInstructor;
    const dataToSave = { ...rest, instructor: instructorName };
    this.savedData = dataToSave;
    this.showPopup = true;
    this.resetCentros();
  }

  saveChanges(centro: CentroEntrenamiento): void {
    centro.disableValidation = false; // Enable validation before saving

    if (centro.id === 0) {
      // New centro
      this.centrosEntrenamientoService.addCentro(centro).subscribe(
        (newCentroData) => {
          this.afterSave(newCentroData);
        },
        (err) => {
          console.error('Error adding centro:', err);
        }
      );
    } else {
      // Existing centro
      this.centrosEntrenamientoService.updateCentro(centro).subscribe(
        (updatedCentro) => {
          this.afterUpdate(updatedCentro);
        },
        (err) => {
          console.error('Error updating centro:', err);
        }
      );
    }
  }

  guardar(centro: CentroEntrenamiento): void {
    // Validate that "nombre" is provided;
    if (!centro.nombre) {
      this.errorMessages[centro.id] = 'Nombre es obligatorio.';
      return;
    } else {
      this.saveChanges(centro);
    }
  }

  cancelar(centro: CentroEntrenamiento): void {
    if (centro.id === 0) {
      this.cancelAddCentro(centro);
    } else {
      this.toggleEditMode(centro);
      this.errorMessages[centro.id] = null;
    }
  }

  onActivosChange(): void {
    if (!this.activos && !this.inactivos) {
      this.inactivos = true; // Ensure at least one checkbox is selected
    }
    this.filterCentros();
  }

  onInactivosChange(): void {
    if (!this.activos && !this.inactivos) {
      this.activos = true; // Ensure at least one checkbox is selected
    }
    this.filterCentros();
  }

  closePopup(): void {
    this.showPopup = false;
    this.savedData = null;
  }
}